{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "นัดหมายแล้ว",
      "confirmed": "ยืนยันแล้ว",
      "completed": "เสร็จสิ้น",
      "cancelled": "ยกเลิกแล้ว",
      "no-show": "ไม่มาตามนัด",
      "checked-in": "เช็คอินแล้ว"
    },
    "resultStatus": {
      "final": "ผลสุดท้าย",
      "preliminary": "ผลเบื้องต้น",
      "corrected": "แก้ไขแล้ว"
    },
    "allergySeverity": {
      "severe": "รุนแรง",
      "high": "สูง",
      "moderate": "ปานกลาง"
    },
    "nationalIdType": {
      "NRIC": "NRIC (สิงคโปร์)",
      "HKID": "HKID (ฮ่องกง)",
      "MyKad": "MyKad (มาเลเซีย)",
      "Aadhaar": "Aadhaar (อินเดีย)",
      "KTP": "KTP (อินโดนีเซีย)",
      "Passport": "หนังสือเดินทาง"
    },
    "messageSenderType": {
      "provider": "ผู้ให้บริการ",
      "patient": "ผู้ป่วย"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "รหัสผ่านไม่ตรงกัน",
      "passwordMinLength": "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"
    }
  },
  "labels": {
    "abnormal": "ผิดปกติ"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "สุขภาพของฉัน",
        "results": "ผลตรวจ",
        "appointments": "การนัดหมาย",
        "messages": "ข้อความ",
        "forms": "แบบฟอร์ม"
      },
      "signOut": "ออกจากระบบ",
      "signOutAria": "ออกจากระบบ",
      "navAria": "การนำทางพอร์ทัล",
      "footer": "พอร์ทัลผู้ป่วย VynaEMR — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "พอร์ทัลผู้ป่วย",
      "labels": {
        "email": "อีเมล",
        "password": "รหัสผ่าน"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "ใส่รหัสผ่านของคุณ"
      },
      "button": {
        "signIn": "เข้าสู่ระบบ",
        "signingIn": "กำลังเข้าสู่ระบบ..."
      },
      "toast": {
        "welcome": "ยินดีต้อนรับกลับ!",
        "invalid": "อีเมลหรือรหัสผ่านไม่ถูกต้อง"
      },
      "links": {
        "noAccount": "ยังไม่มีบัญชี?",
        "register": "ลงทะเบียน"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "อรุณสวัสดิ์",
        "afternoon": "สวัสดีตอนบ่าย",
        "evening": "สวัสดีตอนเย็น",
        "fallbackName": "คุณ"
      },
      "subtitle": "นี่คือสรุปสุขภาพของคุณ",
      "error": "ไม่สามารถโหลดสรุปสุขภาพของคุณได้ โปรดลองอีกครั้งในภายหลัง",
      "demographics": {
        "ageLabel": "อายุ {{age}} ปี",
        "bloodTypeLabel": "หมู่เลือด: {{bloodType}}"
      },
      "quickLinks": {
        "results": "ผลตรวจ",
        "appointments": "การนัดหมาย",
        "messages": "ข้อความ",
        "forms": "แบบฟอร์ม"
      },
      "sections": {
        "allergies": "การแพ้",
        "activeMedications": "ยาที่ใช้ปัจจุบัน",
        "activeProblems": "ปัญหาสุขภาพปัจจุบัน",
        "upcomingAppointments": "การนัดหมายที่กำลังจะมาถึง",
        "recentResults": "ผลตรวจล่าสุด",
        "immunizations": "ประวัติการฉีดวัคซีน",
        "emergencyContact": "ผู้ติดต่อฉุกเฉิน"
      },
      "states": {
        "noAllergies": "ไม่มีการแพ้ที่บันทึกไว้",
        "noMedications": "ไม่มียาที่ใช้ปัจจุบัน",
        "noAppointments": "ไม่มีการนัดหมายที่กำลังจะมาถึง",
        "noResults": "ไม่มีผลตรวจล่าสุด"
      },
      "moreCount": "+อีก {{count}} รายการ",
      "sinceDate": "ตั้งแต่ {{date}}",
      "doseNumber": "เข็มที่ {{number}}",
      "viewAll": "ดูทั้งหมด",
      "providerTBD": "ยังไม่ระบุแพทย์"
    },
    "register": {
      "subtitle": "สร้างบัญชีของคุณ",
      "labels": {
        "fullName": "ชื่อ-นามสกุล",
        "email": "อีเมล",
        "dateOfBirth": "วันเกิด",
        "phone": "โทรศัพท์",
        "mrn": "MRN (เลขเวชระเบียน)",
        "idType": "ประเภทบัตรประจำตัว",
        "idNumber": "เลขบัตรประจำตัว",
        "password": "รหัสผ่าน",
        "confirmPassword": "ยืนยันรหัสผ่าน"
      },
      "placeholders": {
        "fullName": "ใส่ชื่อ-นามสกุลของคุณ",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "ใส่เลขบัตรประจำตัวของคุณ",
        "password": "อย่างน้อย 8 ตัวอักษร",
        "confirmPassword": "ใส่รหัสผ่านของคุณอีกครั้ง",
        "selectIdType": "เลือก..."
      },
      "mrnHint": "หากต้องการเชื่อมบัญชีของคุณกับเวชระเบียน โปรดระบุ MRN หรือเลขบัตรประจำตัวประชาชนของคุณ",
      "button": {
        "createAccount": "สร้างบัญชี",
        "creatingAccount": "กำลังสร้างบัญชี..."
      },
      "toast": {
        "success": "ลงทะเบียนสำเร็จ โปรดเข้าสู่ระบบ",
        "failure": "ลงทะเบียนไม่สำเร็จ โปรดลองอีกครั้ง"
      },
      "links": {
        "haveAccount": "มีบัญชีอยู่แล้ว?",
        "signIn": "เข้าสู่ระบบ"
      },
      "aria": {
        "dateOfBirth": "วันเกิด"
      }
    },
    "appointments": {
      "title": "นัดหมาย",
      "subtitle": "ดูและจัดการนัดหมายของคุณ",
      "error": "ไม่สามารถโหลดนัดหมายได้ โปรดลองอีกครั้งในภายหลัง",
      "sections": {
        "upcoming": "นัดหมายที่จะมาถึง",
        "past": "นัดหมายที่ผ่านมา"
      },
      "states": {
        "noUpcoming": "ไม่มีนัดหมายที่จะมาถึง",
        "noPast": "ไม่มีนัดหมายที่ผ่านมา"
      },
      "reasonLabel": "เหตุผล: {{reason}}",
      "instructionsLabel": "คำแนะนำ: {{instructions}}",
      "durationMinutes": "{{minutes}} นาที",
      "actions": {
        "cancel": "ยกเลิก",
        "confirmCancel": "ยืนยัน",
        "cancelling": "กำลังยกเลิก...",
        "keep": "คงไว้"
      },
      "toast": {
        "cancelSubmitted": "ส่งคำขอยกเลิกแล้ว ทีมดูแลของคุณจะยืนยันให้",
        "cancelFailed": "ยกเลิกนัดหมายไม่สำเร็จ โปรดติดต่อสำนักงาน"
      }
    },
    "results": {
      "title": "ผลตรวจของฉัน",
      "subtitle": "ดูผลตรวจห้องปฏิบัติการและภาพถ่ายของคุณ",
      "error": "ไม่สามารถโหลดผลตรวจได้ โปรดลองอีกครั้งในภายหลัง",
      "referenceRange": "(ค่าอ้างอิง: {{range}})",
      "states": {
        "noResults": "ไม่มีผลตรวจ"
      }
    },
    "messages": {
      "title": "ข้อความ",
      "subtitle": "ติดต่อสื่อสารกับทีมดูแลของคุณ",
      "error": "ไม่สามารถโหลดข้อความได้ โปรดลองอีกครั้งในภายหลัง",
      "fromSender": "จาก {{name}}",
      "labels": {
        "subject": "หัวข้อ",
        "message": "ข้อความ",
        "reply": "ตอบกลับ"
      },
      "placeholders": {
        "subject": "หัวข้อข้อความ",
        "message": "พิมพ์ข้อความของคุณ...",
        "reply": "พิมพ์คำตอบกลับของคุณ..."
      },
      "actions": {
        "newMessage": "ข้อความใหม่",
        "back": "กลับไปที่รายการข้อความ",
        "sendMessage": "ส่งข้อความ",
        "sendReply": "ส่งคำตอบกลับ",
        "sending": "กำลังส่ง..."
      },
      "states": {
        "noMessages": "ยังไม่มีข้อความ"
      },
      "thread": {
        "fromSenderWithType": "จาก {{name}} ({{type}})"
      },
      "compose": {
        "title": "ข้อความใหม่",
        "subtitle": "ข้อความของคุณจะถูกส่งไปยังทีมดูแลของคุณ"
      },
      "toast": {
        "sent": "ส่งข้อความแล้ว",
        "sendFailed": "ส่งข้อความไม่สำเร็จ"
      }
    },
    "forms": {
      "title": "แบบฟอร์ม",
      "subtitle": "กรอกแบบฟอร์มและแบบสอบถามที่จำเป็น",
      "error": "ไม่สามารถโหลดแบบฟอร์มได้ กรุณาลองอีกครั้งในภายหลัง",
      "sections": {
        "pending": "ยังไม่ส่ง",
        "completed": "ส่งแล้ว"
      },
      "labels": {
        "required": "จำเป็น"
      },
      "placeholders": {
        "select": "เลือก..."
      },
      "actions": {
        "fillOut": "กรอก",
        "back": "กลับไปยังแบบฟอร์ม",
        "submit": "ส่งแบบฟอร์ม",
        "submitting": "กำลังส่ง..."
      },
      "states": {
        "noPending": "ไม่มีแบบฟอร์มที่ยังไม่ส่ง",
        "noCompleted": "ไม่มีแบบฟอร์มที่ส่งแล้ว",
        "noFields": "แบบฟอร์มนี้ไม่มีช่องให้กรอก"
      },
      "toast": {
        "submitted": "ส่งแบบฟอร์มสำเร็จแล้ว",
        "submitFailed": "ส่งแบบฟอร์มไม่สำเร็จ"
      }
    }
  }
}
